import { render } from "./СookieNotification.vue?vue&type=template&id=273699ce"
import script from "./СookieNotification.vue?vue&type=script&lang=js"
export * from "./СookieNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__